import {writeStore} from '../helpers'

export const hideColumn = ({visibleColumns, header, tableName}) => {
	const thisColumn = header.id
	const oldVisible = visibleColumns._map('id')
	const visible = oldVisible.filter(column => column !== thisColumn)

	writeStore(tableName, {visible})
}
